/* global axios */
import ApiClient from './ApiClient';

// CRM "Recompra" (Vincto) — perfil 360, pedidos e ocasiões do cliente.
// Um único client cobre os sub-recursos sob /crm (customers/orders/occasions).
class CrmAPI extends ApiClient {
  constructor() {
    super('crm', { accountScoped: true });
  }

  // Perfil 360: contato + agregados + pedidos + ocasiões
  customerProfile(contactId) {
    return axios.get(`${this.url}/customers/${contactId}/profile`);
  }

  // Pedidos
  getOrders(contactId) {
    const params = contactId ? { contact_id: contactId } : {};
    return axios.get(`${this.url}/orders`, { params });
  }

  createOrder(data) {
    return axios.post(`${this.url}/orders`, data);
  }

  updateOrder(id, data) {
    return axios.patch(`${this.url}/orders/${id}`, data);
  }

  deleteOrder(id) {
    return axios.delete(`${this.url}/orders/${id}`);
  }

  // Ocasiões / datas
  getOccasions({ contactId, active } = {}) {
    const params = {};
    if (contactId) params.contact_id = contactId;
    if (active !== undefined) params.active = active;
    return axios.get(`${this.url}/occasions`, { params });
  }

  createOccasion(data) {
    return axios.post(`${this.url}/occasions`, data);
  }

  updateOccasion(id, data) {
    return axios.patch(`${this.url}/occasions/${id}`, data);
  }

  deleteOccasion(id) {
    return axios.delete(`${this.url}/occasions/${id}`);
  }

  // Autorizacao do cliente para receber oferta (registrada com data e origem)
  setConsent(contactId, allowed) {
    return axios.patch(`${this.url}/customers/${contactId}/consent`, {
      allowed,
    });
  }

  // Opcao da conta: quem ja comprou pode receber oferta (com saida por SAIR)
  updateSettings(data) {
    return axios.patch(`${this.url}/settings`, data);
  }

  // Traz as vendas ja ganhas no Kanban para o historico de compras
  importKanbanSales() {
    return axios.post(`${this.url}/imports/kanban`);
  }

  // Campanhas antigas da Recompra: só leitura e exclusão (viraram automações Em uma data)
  getCampaigns() {
    return axios.get(`${this.url}/campaigns`);
  }

  deleteCampaign(id) {
    return axios.delete(`${this.url}/campaigns/${id}`);
  }

  // Modelo (CSV com BOM) de importação — requer auth admin, por isso via API
  downloadImportTemplate() {
    return axios.get(`${this.url}/imports/template`, { responseType: 'blob' });
  }

  // Importar planilha CSV de clientes/pedidos/ocasiões (multipart)
  importSpreadsheet(file) {
    const formData = new FormData();
    formData.append('file', file);
    return axios.post(`${this.url}/import`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }
}

export default new CrmAPI();
